<template>
  <div class="audit-table">
    <div class="container">
      <!-- 导航条 -->
      <div class="toc-wrapper">
        <div class="toc">
          <div v-for="(item, key) in forms" :key="key">
            <a v-smooth-scroll="scrollOptions" :href="'#' + key" :class="{ active: item.active }">{{ item.name }}</a>
            <span :class="['red-point', item.reasonCount > 0 ? '' : 'blank']">{{ item.reasonCount }}</span>
          </div>
        </div>
      </div>
      <div v-show="errorsCount > 0" class="errors">有 {{ errorsCount }} 条信息需要修改，请修改后重新提交</div>
      <!-- 表单组件 -->
      <div class="content">
        <div v-for="(item, key) in forms" :key="key">
          <div :id="key" class="title">{{ item.name }}</div>
          <component
            :is="item.component"
            :ref="key"
            :status="editStatus"
            @updateReasonCount="updateReasonCount"
          ></component>
        </div>
      </div>
    </div>
    <!-- 底部按钮 -->
    <div v-if="status === 2" class="btn-group-wrapper">
      <div class="btn-group">
        <el-button
          v-if="editStatus === 1"
          class="mi-primary"
          size="mini"
          @click="() => { editStatus = 2 }"
        >
          修改信息
        </el-button>
        <el-button
          v-if="editStatus === 2"
          class="mi-primary"
          size="mini"
          :disabled="saveBtnDisabled"
          @click="submitForm"
        >
          重新提交
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ContactForm from '@/components/forms/ContactForm.vue'
import CompanyForm from '@/components/forms/CompanyForm.vue'
import LegalForm from '@/components/forms/LegalForm.vue'
import CategoryForm from '@/components/forms/CategoryForm.vue'
import BrandForm from '@/components/forms/BrandForm.vue'

export default {
  components: {
    ContactForm,
    CompanyForm,
    LegalForm,
    CategoryForm,
    BrandForm
  },
  props: {
    status: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      editStatus: 2, // 1: 禁止修改 2: 允许修改
      saveBtnDisabled: false,
      scrollOptions: {
        duration: 1000,
        offset: -100,
        container: '#main'
      },
      forms: {
        contactForm: { name: '联系人信息', reasonCount: 0, active: false, component: ContactForm },
        companyForm: { name: '企业信息', reasonCount: 0, active: false, component: CompanyForm },
        legalForm: { name: '法人信息', reasonCount: 0, active: false, component: LegalForm },
        categoryForm: { name: '类目信息', reasonCount: 0, active: false, component: CategoryForm },
        brandForm: { name: '品牌信息', reasonCount: 0, active: false, component: BrandForm }
      }
    }
  },
  computed: {
    // 统计错误总数
    errorsCount() {
      return Object.values(this.forms).reduce((acc, cur) => acc + cur.reasonCount, 0)
    }
  },
  mounted() {
    this.handleTocScroll()
    document.getElementById('main').addEventListener('scroll', () => {
      this.handleTocScroll()
    })
  },
  methods: {
    /**
     * 获取表单加签个数
     * @param {string} formName
     * @param {number} value
     */
    updateReasonCount(formName, value) {
      this.forms[formName].reasonCount = value
    },
    /**
     * 提交表单
     */
    async submitForm() {
      let done = true
      this.saveBtnDisabled = true
      for (let formName of Object.keys(this.forms)) {
        console.log('submit', formName)
        try {
          const form = this.$refs[formName][0]
          await form.submitForm('ruleForm', false)
        } catch {
          done = false
          this.editStatus = 2
          break
        }
      }
      this.saveBtnDisabled = false
      if (done) window.location.reload()
    },
    /**
     * 处理 TOC 滚动
     */
    handleTocScroll() {
      const scrollTop = document.getElementById('main').scrollTop - 148
      const keys = Object.keys(this.forms)
      const offsetList = keys.map(k => document.getElementById(k).offsetTop)
      let index = 0
      while (scrollTop >= offsetList[index]) index++
      index = index < 1 ? index = 0 : index - 1
      Object.values(this.forms).forEach((item) => { item.active = false })
      this.forms[keys[index]].active = true
    }
  }
}
</script>

<style lang="less">
.audit-table {
  width: 100%;

  .toc-wrapper {
    position: sticky;
    top: 0;

    .toc {
      position: absolute;
      text-align: right;
      font-size: 18px;
      line-height: 44px;
      width: 160px;
      right: 20px;
      top: 200px;

      a {
        color: #333333;
        font-weight: 500;
        cursor: pointer;
        &.active, &:hover {
          color: #457BFC;
        }
      }

      .red-point {
        display: inline-block;
        width: 18px;
        height: 18px;
        line-height: 20px;
        border-radius: 9px;
        font-size: 14px;
        color: #fff;
        text-align: center;
        font-weight: 500;
        margin-left: 5px;
        background: #FF7677;

        &.blank {
          background: #fff;
        }
      }
    }
  }

  .title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 15px;
    margin-left: 5px;
  }

  .btn-group-wrapper {
    padding: 20px 0;

    .btn-group {
      width: 1200px;
      margin: 0 auto;
      padding-left: 50px;
    }
  }

  .container {
    width: 1200px;
    margin: 0 auto;
    position: relative;

    .errors {
      height: 38px;
      margin-top: 8px;
      padding: 0 15px;
      line-height: 38px;
      font-size: 12px;
      color: #FF7677;
      background: #FFF6F6;
      border-radius: 2px;
      border-radius: 2px;
    }

    .head__inner {
      margin-left: -130px !important;
      margin-right: -130px !important;
      h3 {
        padding-left: 30px !important;
      }
    }
  }

  .tabs {
    display: flex;
    margin-left: 1px;

    .tab {
      width: 175px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #999;
      background: #F2F8FC;
      border: 1px solid #DAE7EF;
      margin-left: -1px;
      transition: all 0.3s ease-out;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        background: #f9ffff;
      }

      &.active {
        background: #fff;
        border: 1px solid transparent;
        border-left: 1px solid #DAE7EF;
        color: #333333;
        font-weight: 500;

        &:first-child {
          border-left: 1px solid transparent;
        }
      }
    }
  }

  .subtabs {
    margin: 20px;
    border-bottom: 1px solid #DEDDDD;
    overflow: hidden;

    .subtab {
      position: relative;
      float: left;
      font-size: 14px;
      line-height: 14px;
      margin: 0 10px 0 30px;
      padding: 10px;
      color: #333333;
      border-bottom: 3px solid transparent;
      cursor: pointer;

      &.active {
        border-color: #457BFC;
        color: #457BFC;
        font-weight: 500;
      }
    }
  }

  .content {
    padding-top: 20px;

    .el-form {
      .el-form-item__label,
      .el-checkbox__label,
      .el-form-item__content,
      .el-radio__label {
        font-size: 12px;
      }
      .el-radio {
        font-weight: normal;
      }
    }

    .el-input {
      width: 480px;
    }

    input,
    .el-textarea__inner,
    .el-upload {
      border-radius: 0;
    }

    .el-textarea {
      width: 480px;
    }
    .el-checkbox-group {
      width: 200px;
      display: inline-block;
    }

    .el-date-editor {
      width: 160px;
    }

    .el-select {
      width: 160px;
      .el-input {
        width: 100%;
      }
    }

    .tree {
      .el-col-4 {
        width: 100px;
        padding: 0 !important;
      }
    }

    .el-tree {
      width: 330px;
      border: 1px solid #d6d6d6;
      max-height: 300px;
      overflow-y: scroll;
      margin: 5px 0 0 0;
      transform: translateX(-100px);
      .el-tree-node__label {
        font-size: 12px;
      }
    }
    .avatar-uploader {
      display: flex;
    }
    .avatar-uploader .el-upload {
      border: 1px solid #dddddd;
      // border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 75px;
      height: 75px;
      line-height: 75px;
      text-align: center;
    }
    .avatar {
      width: 75px;
      // height: 75px;
      display: block;
    }
  }

  .el-button {
    min-width: 90px;
  }

  .avatar-uploader {

    &.inactive {

      .el-upload {
        border: 1px dashed #cecece !important;
        background: #F9F9F9;
        width: 90px;
        height: 90px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
      }

      .avatar-uploader-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-weight: 700;
        color: #fff;
        width: 24px;
        height: 24px;
        background: #e2e2e2;
        border-radius: 24px;
      }
    }

    .el-upload {
      border: 1px dashed transparent !important;
      overflow: inherit !important;
      margin-top: 6px;
      margin-bottom: 10px;

      img {
        border-radius: 4px;
        border: none;
        width: 90px;
        height: 90px;
        object-fit:cover;
      }
    }

    .btn-close {
      position: absolute;
      right: -10px;
      top: -10px;
      cursor: pointer;

      img {
        width: 20px;
        height: 20px;
      }

      &:hover {
        opacity: 0.5;
      }
    }

    .el-textarea__inner {
      height: 80px;
      resize: none;
      color: #333;
      line-height: 17px;
      padding: 3px 5px;
    }
  }

  .red-count {
    position: absolute;
    right: 0;
    top: 2px;
    width: 15px;
    height: 15px;
    line-height: 16px;
    border-radius: 15px;
    float: right;
    color: #fff;
    font-weight: 500;
    font-size: 12px;
    text-align: center;
    background: #E00C0C;
  }
}
</style>
